import React from 'react';
import {
  Container,
  Typography,
  Stack,
  IconButton,
  Link,
  Paper,
  Box,
  Button,
  useTheme,
  styled,
} from '@mui/material';
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationOnIcon,
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
} from '@mui/icons-material';

const locations = [
  {
    name: 'Winston‑Salem Location',
    address: '664 E Monmouth St, Winston‑Salem, NC 27107',
    email: '5starlaundromatnc@gmail.com',
    phone: '+1(336) 624-5244',
    facebook: 'https://www.facebook.com/people/5-Star-Laundromat/61573570883192/',
    instagram: 'https://www.instagram.com/5starlaundromats/',
    directionLink: 'https://maps.app.goo.gl/NU93FonLJW9dEGgG8',
  },
];
const ContactRow = ({ Icon, href = "#", children, iconColor = 'primary' }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 1 }}>
      <Icon color={iconColor} sx={{ mr: 1 }} />
      {href ? (
        <Link href={href} target={href.startsWith('http') ? '_blank' : undefined} underline="none">
          {children}
        </Link>
      ) : (
        children
      )}
    </Box>
  );
  

const Location = ({ name, address, email, phone, facebook, instagram, directionLink }) => (
  <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: 3, textAlign: 'center', bgcolor: '#e3f2fd' }}>
    <Box sx={{ p: 2, bgcolor: '#bbdefb', borderRadius: '8px 8px 0 0' }}>
      <Typography variant="h6" fontWeight="bold">{name}</Typography>
    </Box>

    <ContactRow Icon={LocationOnIcon} href={'https://maps.app.goo.gl/N2p6Fnrc3bWMz8np8'}>{address}</ContactRow>
    <ContactRow Icon={PhoneIcon} href={`tel:${phone}`} iconColor="success">{phone}</ContactRow>
    <ContactRow Icon={EmailIcon} href={`mailto:${email}`}>{email}</ContactRow>

    <Box sx={{ mt: 2 }}>
      {[{ Icon: FacebookIcon, href: facebook }, { Icon: InstagramIcon, href: instagram }].map(({ Icon, href }) => (
        <IconButton key={href} component="a" href={href} target="_blank">
          <Icon fontSize="large" />
        </IconButton>
      ))}
    </Box>

    <Button variant="contained" sx={{ mt: 2 }} href={directionLink} target="_blank">
      Get Directions
    </Button>
  </Paper>
);
const HeaderSection = styled(Box)(({ theme }) => ({
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.background.paper})`,
    padding: "40px 20px",
    textAlign: "center",
    borderBottomLeftRadius: "30px",
    borderBottomRightRadius: "30px",
    color: theme.palette.text.primary,
}));

const ContactUs = () => {
  const theme = useTheme();

  return (
    <Box sx={{ bgcolor: theme.palette.background.default }}>
        <HeaderSection>
        <Typography variant="h4" fontWeight="bold">Contact Us</Typography>
        </HeaderSection>
      <Container sx={{ py: 4 }}>
        <Stack spacing={2} alignItems="center">
          {locations.map((loc, i) => <Location key={i} {...loc} />)}
        </Stack>
      </Container>
    </Box>
  );
};

export default ContactUs;
